<template lang="pug">
  // Question and Quiz tabs
  el-main()
    el-tabs(v-loading="processing"
      type="border-card"
      @tab-click="onTabClick")
      
      el-tab-pane(
        label="Quiz Information")   
        quiz-info-view(
          @onQuizDelete="refreshQuestionList"
          @onProcessing="(flag) => processing = flag")
      
      el-tab-pane(label="Questions")
        question-list(
          :quizData="$store.state.quizData"
          :placeholderList="randomArray"
          @onProcessing="(flag) => processing = flag")
</template>

<script>
import QuizInfoView from '@/components/instructor/QuizInfoView'
import QuestionList from '@/components/instructor/Question/QuestionList'

export default {
  name: 'Quiz',

  components: {
    QuizInfoView,
    QuestionList,
  },  

  data() {
    return {
      processing: true,
      refreshList: false,
      randomArray: [],
    }
  },

  methods: {
    onTabClick(tab, event) {
      this.randomArray = []
      for(let i=0; i<1; i++) {
        this.randomArray.push({
          id: Math.floor(Math.random() * (Math.floor(10) - Math.ceil(1) + 1)) + Math.ceil(1),
          score: '10',
          title: 'Question',
          text: 'Here is a sample "Answer-Input question. Select the pencil icon to make it your own.',
          lefthand: '',
          righthand: '',
          correct_answer: '',    
          custom_symbols: [],
          type_id: 1,
          allomathequivs: false,
        })
      }
    },

    refreshQuestionList() {
      this.refreshList = !this.refreshList
    },
  },
}
</script>
